import { DEFAULT_SCENARIO_SETTINGS, TIMELINE_VALUES, type TimelineOption } from "consts";

/** A supported timeline length, or the fallback when the value is not one. */
export const toTimelineOption = (value: number, fallback: TimelineOption = DEFAULT_SCENARIO_SETTINGS.timeline): TimelineOption =>
  (TIMELINE_VALUES as readonly number[]).includes(value) ? (value as TimelineOption) : fallback;
